import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";
export var StatefulAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(StatefulAccessor, _Accessor);

  function StatefulAccessor(key, urlString) {
    var _this;

    _classCallCheck(this, StatefulAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StatefulAccessor).call(this));
    _this.key = key;
    _this.urlKey = urlString || key && key.replace(/\./g, "_");
    _this.urlWithState = _this.urlWithState.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StatefulAccessor, [{
    key: "onStateChange",
    value: function onStateChange(_oldState) {}
  }, {
    key: "fromQueryObject",
    value: function fromQueryObject(ob) {
      var value = ob[this.urlKey];
      this.state = this.state.setValue(value);
    }
  }, {
    key: "getQueryObject",
    value: function getQueryObject() {
      var val = this.state.getValue();
      return val ? _defineProperty({}, this.urlKey, val) : {};
    }
  }, {
    key: "setSearchkitManager",
    value: function setSearchkitManager(searchkit) {
      _get(_getPrototypeOf(StatefulAccessor.prototype), "setSearchkitManager", this).call(this, searchkit);

      this.uuid = this.key + this.uuid;
      this.fromQueryObject(searchkit.state);
      searchkit.query = searchkit.buildQuery();
      this.setResultsState();
    }
  }, {
    key: "setResults",
    value: function setResults(results) {
      _get(_getPrototypeOf(StatefulAccessor.prototype), "setResults", this).call(this, results);

      this.setResultsState();
    }
  }, {
    key: "setResultsState",
    value: function setResultsState() {
      this.resultsState = this.state;
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.state = this.state.clear();
    }
  }, {
    key: "urlWithState",
    value: function urlWithState(state) {
      return this.searchkit.buildSearchUrl(_defineProperty({}, this.urlKey, state));
    }
  }]);

  return StatefulAccessor;
}(Accessor);